<!-- @format -->
<binding-tag>
    <slot/>
    <script>
        import debounce from 'debounce-promise';
        import di       from "dependency-injection";
        import works    from "@model/works/api";

        export default {
            works: works,
            input: null,
            setBinding() {
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') || 
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.value    = this.works.item[this.props.name]
                    this.root.onkeyup  = this.input
                    this.root.onchange = this.input
                    this.root.onpaste  = this.input
                    this.root.onblur   = this.input
                } else if (this.root.type === 'checkbox') {
                    this.root.value = this.root.hasAttribute('val') 
                                    ? this.root.getAttribute('val') : null
                    if (this.works.item[this.props.name] == this.root.value) {
                        this.root.checked = true
                    }
                    this.root.onclick = this.input
                }
            },
            setValid(valid) {
                if (valid) {
                    this.root.classList.remove('is-error')
                    if (null !== this.root.parentElement) {
                        let errors = this.root.parentElement.getElementsByClassName('error')
                        for (let error of errors) {
                            this.root.parentElement.removeChild(error)
                        }
                    }
                } else {
                    if (null !== this.root.parentElement) {
                        if (!this.root.classList.contains('is-error')) {
                            this.root.classList.add('is-error')

                            const div = document.createElement('div')
                            div.textContent = this.props.errmsg
                            div.classList.add('error')
                            this.root.parentElement.appendChild(div)
                        }
                    }
                }
            },
            onMounted(props, state) {
                this.input = debounce((e)=> {
                    let value = '';
                    if (this.root.type === 'checkbox') {
                        value = e.target.checked ? parseInt(e.target.value) : ''
                        let key = 'fields_' + this.works.otherId
                        if (key === this.props.name) {
                            this.works.trigger('set:' + key, value)
                        }
                    } else {
                        value = e.target.value
                    }
                    let validation = this.works.getValidation(this.props.name)
                    let valid = this.works.item.set(this.props.name, value, validation)
                    this.works.trigger('set:' + this.props.name, value, valid)
                    let fields = this.props.name.substr(0, 6);
                    this.works.trigger('set:' + fields, value, valid)
                    this.setValid(valid)
                }, 100)

                this.works.on('setValid:' + this.props.name, (valid)=> this.setValid(valid))

                this.setBinding()
            },
            onUnmounted(props, state) {
                this.works.off('setValid:' + this.props.name, (valid)=> this.setValid(valid))
            },
            onUpdated(props, state) {
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') || 
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.value = this.works.item[this.props.name]
                }
            }
        }
    </script>
</binding-tag>